<template>
  <div
    class="bg-white rounded-lg shadow-card p-8 self-start max-w-sm sm:p-12 mb-4"
  >
    <img
      v-if="showIcon"
      width="32"
      height="32"
      src="@/assets/icons/info.svg"
      alt="BuildaBox Order Edit Page"
      class="mb-4 "
    />
    <div class="mb-3">
      <h1 v-if="title" class="font-semibold text-lg">{{ title }}</h1>
      <h1 v-else class="font-semibold text-lg">Helper Info Box</h1>
    </div>
    <p>
      <Spinner :orange="true" class="mx-auto" v-if="isLoading" />
      <slot v-else>this is default value of infobox</slot>
    </p>
  </div>
</template>

<script>
import Spinner from "@/components/common/Spinner"
export default {
  components: {
    Spinner
  },
  name: "InfoBox",
  props: ["title", "isLoading", "showIcon"]
};
</script>

<style scoped></style>
